import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=eaddb6e6&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"
import style0 from "./Content.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaddb6e6')) {
      api.createRecord('eaddb6e6', component.options)
    } else {
      api.reload('eaddb6e6', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=eaddb6e6&", function () {
      api.rerender('eaddb6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Content.vue"
export default component.exports